var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("div", { staticClass: "animated fadeIn" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-card",
                { attrs: { header: "Bootstrap Modals" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "secondary" },
                      on: {
                        click: function ($event) {
                          _vm.myModal = true
                        },
                      },
                    },
                    [_vm._v("\n            Launch demo modal\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "secondary" },
                      on: {
                        click: function ($event) {
                          _vm.largeModal = true
                        },
                      },
                    },
                    [_vm._v("\n            Launch large modal\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "secondary" },
                      on: {
                        click: function ($event) {
                          _vm.smallModal = true
                        },
                      },
                    },
                    [_vm._v("\n            Launch small modal\n          ")]
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.primaryModal = true
                        },
                      },
                    },
                    [_vm._v("\n            Launch primary modal\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "success" },
                      on: {
                        click: function ($event) {
                          _vm.successModal = true
                        },
                      },
                    },
                    [_vm._v("\n            Launch success modal\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "warning" },
                      on: {
                        click: function ($event) {
                          _vm.warningModal = true
                        },
                      },
                    },
                    [_vm._v("\n            Launch warning modal\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dangerModal = true
                        },
                      },
                    },
                    [_vm._v("\n            Launch danger modal\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "info" },
                      on: {
                        click: function ($event) {
                          _vm.infoModal = true
                        },
                      },
                    },
                    [_vm._v("\n            Launch info modal\n          ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Modal title" },
          on: {
            ok: function ($event) {
              _vm.myModal = false
            },
          },
          model: {
            value: _vm.myModal,
            callback: function ($$v) {
              _vm.myModal = $$v
            },
            expression: "myModal",
          },
        },
        [
          _vm._v(
            "\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Modal title", size: "lg" },
          on: {
            ok: function ($event) {
              _vm.largeModal = false
            },
          },
          model: {
            value: _vm.largeModal,
            callback: function ($$v) {
              _vm.largeModal = $$v
            },
            expression: "largeModal",
          },
        },
        [
          _vm._v(
            "\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Modal title", size: "sm" },
          on: {
            ok: function ($event) {
              _vm.smallModal = false
            },
          },
          model: {
            value: _vm.smallModal,
            callback: function ($$v) {
              _vm.smallModal = $$v
            },
            expression: "smallModal",
          },
        },
        [
          _vm._v(
            "\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-primary",
          attrs: { title: "Modal title" },
          on: {
            ok: function ($event) {
              _vm.primaryModal = false
            },
          },
          model: {
            value: _vm.primaryModal,
            callback: function ($$v) {
              _vm.primaryModal = $$v
            },
            expression: "primaryModal",
          },
        },
        [
          _vm._v(
            "\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-success",
          attrs: { title: "Modal title" },
          on: {
            ok: function ($event) {
              _vm.successModal = false
            },
          },
          model: {
            value: _vm.successModal,
            callback: function ($$v) {
              _vm.successModal = $$v
            },
            expression: "successModal",
          },
        },
        [
          _vm._v(
            "\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-warning",
          attrs: { title: "Modal title" },
          on: {
            ok: function ($event) {
              _vm.warningModal = false
            },
          },
          model: {
            value: _vm.warningModal,
            callback: function ($$v) {
              _vm.warningModal = $$v
            },
            expression: "warningModal",
          },
        },
        [
          _vm._v(
            "\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-danger",
          attrs: { title: "Modal title" },
          on: {
            ok: function ($event) {
              _vm.dangerModal = false
            },
          },
          model: {
            value: _vm.dangerModal,
            callback: function ($$v) {
              _vm.dangerModal = $$v
            },
            expression: "dangerModal",
          },
        },
        [
          _vm._v(
            "\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-info",
          attrs: { title: "Modal title" },
          on: {
            ok: function ($event) {
              _vm.infoModal = false
            },
          },
          model: {
            value: _vm.infoModal,
            callback: function ($$v) {
              _vm.infoModal = $$v
            },
            expression: "infoModal",
          },
        },
        [
          _vm._v(
            "\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }